// AccountReferralSkeleton.jsx
import React from "react";
import "./accountReferralSkeleton.css";

const AccountReferralSkeleton = () => {
	return (
		<div className="sf-referral-page">

			{/* HERO */}
			<div className="sf-referral-hero sf-skel-hero">
				<div className="sf-skel-hero-icon shimmer"></div>
				<div className="sf-skel-line shimmer w-50"></div>
				<div className="sf-skel-line shimmer w-70"></div>
				<div className="sf-skel-line shimmer w-40"></div>
			</div>

			{/* REFERRAL CARD */}
			<div className="sf-referral-card sf-skel-card">
				<div className="sf-skel-line shimmer w-30"></div>

				<div className="sf-skel-box shimmer"></div>

				<div className="sf-skel-line shimmer w-30"></div>

				<div className="sf-skel-box shimmer"></div>

				<div className="sf-skel-line shimmer w-80"></div>
			</div>

			{/* HISTORY */}
			<div className="sf-referral-card sf-skel-card">
				<div className="sf-skel-line shimmer w-40"></div>

				{Array.from({ length: 3 }).map((_, i) => (
					<div key={i} className="sf-skel-history-row">
						<div className="sf-skel-line shimmer w-50"></div>
						<div className="sf-skel-badge shimmer"></div>
					</div>
				))}
			</div>
		</div>
	);
};

export default AccountReferralSkeleton;
